/* ============================================================
   CARTRI - Carrito: ahorro acumulado, logros y complementos

   Tres cosas resueltas aqui:
   1. En /cart tambien existe el drawer aunque este oculto. Antes
      se pintaba solo en el primero que aparecia y la pagina de
      carrito se quedaba vacia. Ahora se pinta en todos.
   2. Shopify reemplaza el contenido entero del carrito en cada
      cambio y borra los bloques. Se deja una marca invisible y un
      vigilante los repone.
   3. En el panel lateral hay poco alto: el ahorro y los logros van
      en una linea y los complementos son plegables, para que
      siempre se vean productos del carrito.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.LIQ || {};
  if (!CFG.enabled) return;
  var S = CFG.strings || {};
  var MAPA = CFG.compareAt || {};

  var money = function (c) {
    try {
      return new Intl.NumberFormat(CFG.locale || 'es-ES', {
        style: 'currency', currency: CFG.currency || 'EUR'
      }).format(c / 100);
    } catch (e) { return (c / 100).toFixed(2) + ' EUR'; }
  };
  var root = function () {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  };
  var esc = function (s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };
  var esBolsa = function (t) { return /paletero|mochila/i.test(t || ''); };

  var sucio = true;
  var pintando = false;
  var abierto = false; // recuerda si el usuario dejo abiertos los complementos

  function hostsCarrito() {
    var a = [];
    var d = document.querySelector('cart-drawer .drawer__inner');
    var c = document.querySelector('#main-cart-items');
    if (d) a.push(d);
    if (c) a.push(c);
    return a;
  }

  function faltaMarca() {
    var hs = hostsCarrito();
    if (!hs.length) return false;
    for (var i = 0; i < hs.length; i++) {
      if (!hs[i].querySelector('[data-liq-mark]')) return true;
    }
    return false;
  }

  function calcAhorro(cart) {
    var saved = 0;
    cart.items.forEach(function (i) {
      var antes = MAPA[String(i.variant_id)];
      if (!antes) antes = i.original_price || i.price;
      saved += (antes * i.quantity) - i.final_line_price;
    });
    return saved > 0 ? saved : 0;
  }

  function savedHTML(cart) {
    var saved = calcAhorro(cart);
    if (saved <= 0) return '';
    return '<div class="liq-saved" data-liq-saved>' +
      '<span class="liq-saved__label">' + (S.savedTitle || 'Te estas ahorrando') + '</span>' +
      '<span class="liq-saved__amount">' + money(saved) + '</span>' +
      '<span class="liq-saved__note">' + (S.savedNote || '') + '</span></div>';
  }

  function achHTML(cart) {
    var out = '';
    var umbral = CFG.freeShippingThreshold || 0;
    if (umbral) {
      var left = umbral - cart.total_price;
      var done = left <= 0;
      var pct = Math.min(100, Math.round((cart.total_price / umbral) * 100));
      out += '<div class="liq-ach' + (done ? ' is-done' : '') + '">' +
        '<span class="liq-ach__icon">' + (done ? '&#10003;' : '1') + '</span>' +
        '<span class="liq-ach__body"><span class="liq-ach__title">' +
        (done ? (S.achShipping || 'Envio gratis desbloqueado')
              : (S.shipLeft || 'Te faltan {{amount}} para el envio gratis').replace('{{amount}}', money(left))) +
        '</span>' +
        (done ? '<span class="liq-ach__note">' + (S.achShippingNote || '') + '</span>'
              : '<span class="liq-ach__track"><span class="liq-ach__fill" style="width:' + pct + '%"></span></span>') +
        '</span></div>';
    }
    var ids = (CFG.crossPool || []).map(function (o) { return String(o.variantId); });
    var n = 0;
    cart.items.forEach(function (i) { if (ids.indexOf(String(i.variant_id)) > -1) n += i.quantity; });
    if (n > 0) {
      var listo = n >= 3;
      var faltan = 3 - n;
      out += '<div class="liq-ach' + (listo ? ' is-done' : '') + '">' +
        '<span class="liq-ach__icon">' + (listo ? '&#10003;' : '2') + '</span>' +
        '<span class="liq-ach__body"><span class="liq-ach__title">' +
        (listo ? (S.ach3x2 || '3x2 en complementos activo')
               : 'Te ' + (faltan === 1 ? 'falta 1 complemento' : 'faltan ' + faltan + ' complementos') + ' para el 3x2') +
        '</span><span class="liq-ach__note">' + (S.ach3x2Note || '') + '</span></span></div>';
    }
    return out;
  }

  function elegir(cart) {
    var dentro = cart.items.map(function (i) { return String(i.variant_id); });
    var libres = (CFG.crossPool || []).filter(function (o) {
      return o && o.available && dentro.indexOf(String(o.variantId)) === -1;
    });
    if (!libres.length) return [];
    var bolsas = libres.filter(function (o) { return esBolsa(o.type); });
    var otros = libres.filter(function (o) { return !esBolsa(o.type); });
    var pick = otros.slice(0, 2);
    if (bolsas.length) pick.push(bolsas[0]);
    var i = pick.length;
    while (pick.length < 3 && otros[i]) { pick.push(otros[i]); i++; }
    return pick.slice(0, 3);
  }

  function filas(pick, sufijo, premarcar) {
    return pick.map(function (o, idx) {
      var bolsa = esBolsa(o.type);
      var id = 'liq-cc-' + sufijo + '-' + o.variantId;
      var img = o.image
        ? '<img src="' + esc(o.image) + '" alt="" width="88" height="88" loading="lazy">'
        : '<div class="liq-cross__ph"></div>';
      var was = o.compareAt && o.compareAt > o.price ? '<s>' + money(o.compareAt) + '</s>' : '';
      var flag = bolsa ? '<span class="liq-cross__flag">para llevarlo todo</span>' : '';
      return '<label class="liq-cross__item' + (bolsa ? ' liq-cross__item--bolsa' : '') +
        '" for="' + id + '">' +
        '<input type="checkbox" id="' + id + '" value="' + o.variantId +
        '" data-price="' + o.price + '" data-compare="' + (o.compareAt || o.price) + '"' +
        (premarcar && idx === 0 ? ' checked' : '') + '>' + img +
        '<span class="liq-cross__name">' + esc(o.title) + flag + '</span>' +
        '<span class="liq-cross__prices">' + was + '<b>' + money(o.price) + '</b></span></label>';
    }).join('');
  }

  function cuerpo(pick, sufijo, premarcar) {
    return '<div class="liq-cross__box">' +
      '<div class="liq-cross__head"><h2>' + (S.crossCartTitle || 'Completa tu equipo') + '</h2></div>' +
      '<p class="liq-cross__note">' + (S.crossCartNote || '') + '</p>' +
      '<div class="liq-cross__list">' + filas(pick, sufijo, premarcar) + '</div>' +
      '<div class="liq-cross__foot"><div class="liq-cross__total">' +
      (S.crossTotal || 'Total seleccionado:') +
      ' <b data-liq-cc-total>-</b><span data-liq-cc-save></span></div>' +
      '<button type="button" class="liq-cross__btn" data-liq-cc-add>Anadir</button>' +
      '</div></div>';
  }

  function crossHTML(cart, sufijo, compacto) {
    var pick = elegir(cart);
    if (!pick.length) return '';

    if (!compacto) {
      return '<div class="liq-cross liq-cross--cart" data-liq-cart-cross>' +
        cuerpo(pick, sufijo, true) + '</div>';
    }

    // Panel lateral: plegado, para no comerse la lista de productos
    var barato = pick.reduce(function (m, o) { return Math.min(m, o.price); }, Infinity);
    var hint = pick.length + ' desde ' + money(barato);
    return '<details class="liq-cross liq-cross--cart liq-cross--drawer" data-liq-cart-cross' +
      (abierto ? ' open' : '') + '>' +
      '<summary class="liq-cross__toggle">' +
      '<span>' + (S.crossCartTitle || 'Completa tu equipo') + '</span>' +
      '<span class="liq-cross__hint">' + hint + '</span></summary>' +
      cuerpo(pick, sufijo, false) + '</details>';
  }

  function refrescar(box) {
    if (!box) return;
    var boxes = [].slice.call(box.querySelectorAll('input[type="checkbox"][data-price]'));
    var totalEl = box.querySelector('[data-liq-cc-total]');
    var saveEl = box.querySelector('[data-liq-cc-save]');
    var btn = box.querySelector('[data-liq-cc-add]');
    if (!btn) return;
    var total = 0, was = 0, n = 0;
    boxes.forEach(function (c) {
      if (!c.checked) return;
      n++;
      total += Number(c.getAttribute('data-price')) || 0;
      was += Number(c.getAttribute('data-compare')) || 0;
    });
    if (totalEl) totalEl.textContent = money(total);
    if (saveEl) {
      var save = was - total;
      saveEl.textContent = save > 0 ? (S.youSave || 'Ahorras {{amount}}').replace('{{amount}}', money(save)) : '';
    }
    btn.disabled = n === 0;
    btn.textContent = n === 0
      ? (S.crossEmpty || 'Selecciona un complemento')
      : (S.crossAdd || 'Anadir {{n}} al carrito').replace('{{n}}', n);
  }

  function pintar() {
    if (pintando) return;
    if (!hostsCarrito().length) return;
    pintando = true;

    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var viejos = document.querySelectorAll('[data-liq-saved],[data-liq-ach],[data-liq-cart-cross],[data-liq-mark]');
        for (var i = 0; i < viejos.length; i++) {
          if (viejos[i].parentNode) viejos[i].parentNode.removeChild(viejos[i]);
        }

        hostsCarrito().forEach(function (h, idx) {
          h.insertAdjacentHTML('afterbegin', '<span data-liq-mark hidden></span>');
          if (!cart.item_count) return;

          var esDrawer = h.classList.contains('drawer__inner');
          var cabecera = savedHTML(cart) + '<div data-liq-ach>' + achHTML(cart) + '</div>';
          var cross = crossHTML(cart, idx, esDrawer);

          if (esDrawer) {
            var header = h.querySelector('.drawer__header');
            if (header) header.insertAdjacentHTML('afterend', cabecera);
            else h.insertAdjacentHTML('afterbegin', cabecera);
            if (cross) {
              var footer = h.querySelector('.drawer__footer');
              if (footer) footer.insertAdjacentHTML('beforebegin', cross);
              else h.insertAdjacentHTML('beforeend', cross);
            }
          } else {
            h.insertAdjacentHTML('beforebegin', cabecera);
            if (cross) h.insertAdjacentHTML('afterend', cross);
          }
        });

        [].slice.call(document.querySelectorAll('[data-liq-cart-cross]')).forEach(refrescar);
      })
      .catch(function () {})
      .then(function () { pintando = false; sucio = false; });
  }

  function anadir(items, btn) {
    var txt = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = S.adding || 'Anadiendo...'; }
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: items,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.renderContents === 'function' && !document.querySelector('#main-cart-items')) {
          d.renderContents(data);
          sucio = true;
        } else {
          window.location.reload();
        }
      })
      .catch(function () { window.location.reload(); })
      .then(function () {
        if (btn) { btn.disabled = false; if (txt) btn.textContent = txt; }
      });
  }

  document.addEventListener('change', function (e) {
    var box = e.target && e.target.closest ? e.target.closest('[data-liq-cart-cross]') : null;
    if (box) refrescar(box);
  });

  // Recordar si el usuario abrio el desplegable, para no cerrarselo
  // cada vez que Shopify repinta el carrito.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.classList && d.classList.contains('liq-cross--drawer')) abierto = d.open;
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-liq-cc-add]') : null;
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-liq-cart-cross]');
    var items = [];
    [].slice.call(box.querySelectorAll('input[type="checkbox"]:checked')).forEach(function (c) {
      items.push({ id: Number(c.value), quantity: 1 });
    });
    if (items.length) anadir(items, btn);
  });

  function boot() {
    pintar();
    if (window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { if (faltaMarca()) sucio = true; }, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
    setInterval(function () { if (sucio || faltaMarca()) pintar(); }, 700);
    ['cart:refresh', 'cart:update'].forEach(function (ev) {
      document.addEventListener(ev, function () { sucio = true; });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
